export default __webpack_public_path__ + "static/media/tours-travel3.c326824e.jpg";